import * as React from 'react';
export const facebookSvg = React.forwardRef(function facebookSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#4267B2',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.42 32V20.612h3.852l.575-4.458h-4.426v-2.838c0-1.29.361-2.163 2.213-2.163H26v-3.98A32.736 32.736 0 0 0 22.566 7c-3.404 0-5.724 2.072-5.724 5.874v3.28H13v4.458h3.841V32h4.58Z',
      fill: '#fff',
    }),
  );
});
facebookSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var facebook = {
  category: 'brand',
  colorable: false,
  name: 'facebook',
  svg: facebookSvg,
};
